// Size the Tax Inquiry tax record dialog opens at - the pilot for the "stretch narrow
// dialogs horizontally" work. Kept here instead of repeated as a literal on each host so
// the value moves in one place, and so the dialogs that adopt the wide layout next reuse
// the same pair rather than each picking their own vw number.
//
// '98vw' leaves a sliver of the page either side so the dialog still reads as a dialog.
// Vuetify caps .v-dialog at 90% of the viewport height, so '90vh' is the tallest height
// that does not push the Save/Cancel bar out of sight - see the dialogDynamicHeight
// comment in components/common/base/crud-2.0/CRUDDialog.vue.
export const WIDE_DIALOG_WIDTH = '98vw';
export const WIDE_DIALOG_HEIGHT = '90vh';

export default {
  WIDE_DIALOG_WIDTH,
  WIDE_DIALOG_HEIGHT,
};
